// extracted by mini-css-extract-plugin
module.exports = {"bookmarkItem":"BookmarkPill_bookmarkItem__hpZIB","linkButtonContainer":"BookmarkPill_linkButtonContainer__RfHXj","closeIconContainer":"BookmarkPill_closeIconContainer__5UX1S"};